import { ComponentProps } from "@declarations/props";
import { linkPage } from "@utils/router";
import { useLocation, useNavigate } from "react-router-dom";
import {
  LuHome,
  LuLayoutGrid,
  LuReceipt,
  LuShoppingBag,
  LuUser,
} from "react-icons/lu";
import { useState } from "react";

export const BottomNavigation: ComponentProps<{
  type: "home" | "marketplace";
}> = ({ type = "home" }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [show, setShow] = useState<boolean>(true);

  const inputFields = document.querySelectorAll("input, textarea");
  inputFields.forEach((field) => {
    field.addEventListener("focus", () => setShow(false));
    field.addEventListener("blur", () => setShow(true));
  });

  const NavItem = ({
    path,
    icon: Icon,
    label,
  }: {
    path: string;
    icon: React.ElementType;
    label: string;
  }) => {
    const active = location.pathname === path;
    return (
      <div
        onClick={() => navigate(path)}
        className={`btn-link nav-link tab ${active ? "active" : ""}`}
      >
        <Icon size={20} />
        <span className="tw-text-[0.6rem] tw-font-semibold nav-name">
          {label}
        </span>
      </div>
    );
  };

  switch (type) {
    case "home":
      return (
        <nav
          className={`navbar navbar-expand tw-bg-background-100 navbar-home ${
            !show && "navbar-hide"
          }`}
        >
          <ul className="navbar-nav nav-justified tw-w-full">
            <li className="nav-item">
              <NavItem
                path={linkPage.HOME_DASHBOARD}
                icon={LuHome}
                label="Beranda"
              />
              <NavItem
                path={linkPage.MARKETPLACE_PRODUCT}
                icon={LuShoppingBag}
                label="Toko"
              />
              <NavItem
                path="/finance/data-va"
                icon={LuReceipt}
                label="Pembayaran"
              />
              <NavItem
                path={linkPage.HOME_PROFILE}
                icon={LuUser}
                label="Profil"
              />
            </li>
          </ul>
        </nav>
      );

    case "marketplace":
      return (
        <nav className="navbar navbar-expand tw-bg-background-100 navbar-marketplace">
          <ul className="navbar-nav nav-justified tw-w-full">
            <li className="nav-item">
              <NavItem
                path={linkPage.MARKETPLACE_PRODUCT}
                icon={LuShoppingBag}
                label="Produk"
              />
              <NavItem
                path="/finance/data-va"
                icon={LuLayoutGrid}
                label="Keranjang"
              />
              <NavItem
                path={linkPage.HOME_PROFILE}
                icon={LuUser}
                label="Pesanan"
              />
            </li>
          </ul>
        </nav>
      );
  }
};
